/**
 * Снятие встраивания связи в родителя-ноду (см. edgeKeepRootPlugin).
 * Вызывать при bulk-рендере до подключения patch-sync или с выключенной History.
 */
export function detachEdgeFromNodeParent(edge) {
	if (!edge || typeof edge.isEdge !== 'function' || !edge.isEdge()) return;
	const parent = edge.getParent?.();
	if (parent && typeof parent.isNode === 'function' && parent.isNode()) {
		parent.unembed(edge, {silent: true});
	}
}
